module.exports = __webpack_public_path__ + "img/machine_learning.d694ef53.webp";